import VueAxios from 'vue-axios'
import AxiosInstance from './AxiosInstance'

export default (Vue) => {
  Vue.use(VueAxios, AxiosInstance)
}



// WEBPACK FOOTER //
// ./src/utils/Http.js